<template>
  <div v-if="isMyAccount || !dummy">
    <TextLabel class="">{{ label }}</TextLabel>
    <div v-if="dummy" class="row">
      <div class="col">
        {{ dummy }}&nbsp;
        <template v-if="isMyAccount">
          <router-link
            class="purple"
            :to="{
              name: $routerNames.EDIT,
              params: {
                ...account.params,
                ...$route.params,
              },
              hash: '#platforms-accounts-edit',
            }"
            >{{
              $t('_web_profile-info_platforms-add-link', 'Choose platforms')
            }}</router-link
          >
        </template>
      </div>
    </div>
    <div v-else class="row no-gutters">
      <PlatformEntity
        v-for="(platform, index) in accountPlatforms"
        :key="`platform_${platform}_${index}`"
        class="col-auto h-mr-3 mb-3 h-text-left"
        :platform="platform"
        :title="account.platforms[platform]"
        :img-size="24"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import PlatformEntity from '@/components/common/PlatformEntity';
import TextLabel from '@/components/atoms/TextLabel';

export default {
  name: 'AccountInfoPlatforms',
  components: {
    PlatformEntity,
    TextLabel,
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccountId: 'accountId' }),
    ...mapGetters(['platformByID']),
    accountPlatforms() {
      return Object.keys(this.account.platforms || {});
    },
    isMyAccount() {
      return this.accountId === this.myAccountId;
    },
    dummy() {
      return this.$lodash.isEmpty(this.account.platforms)
        ? this.$t('_web_profile-info_no-platforms', 'No Platforms')
        : null;
    },
    label() {
      return this.$t('_web_profile-info_preferable-platforms', `Platforms`, {
        name: this.account._name,
      });
    },
  },
};
</script>

<style lang="scss">
.purple {
  color: #5a58f2;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
